/** Shared text helper for the live-updates preview. `background_check` → `Background check`. */
export function humanize(value: string): string {
  const spaced = value.replace(/[_-]+/g, ' ').trim()

  return spaced.length === 0 ? spaced : spaced.charAt(0).toUpperCase() + spaced.slice(1)
}
